import { Content } from '../useContentData'

interface ContentHeaderProps {
    content: Content
}

/**
 * Enhanced header component for content pages with gradient styling and improved visual hierarchy
 */
export function ContentHeader({
    content
}: ContentHeaderProps) {
    return (
        <div className="space-y-4 flex-1">
            <div className="space-y-3">
                <h1 className="text-4xl font-bold bg-gradient-to-r from-blue-700 via-indigo-700 to-purple-700 bg-clip-text text-transparent">
                    {content.name}
                </h1>
                <div className="relative">
                    <p className="text-gray-600 text-lg leading-relaxed">
                        Preview the content, improve it, and get it in a shareable format here.
                    </p>
                    <div className="absolute -bottom-1 left-0 w-24 h-0.5 bg-gradient-to-r from-blue-500 to-purple-600 opacity-60" />
                </div>
            </div>
        </div>
    )
}